import api from './api';

export const tuyenDungService = {

  getAll: () => api.get('/tuyen-dung'),

  getById: (id) => api.get(`/tuyen-dung/${id}`),

  getByDotTuyenDung: (dotId) => api.get(`/tuyen-dung/dot/${dotId}`),

  chamDiem: (data) => api.post('/hoi-dong/cham-diem', data),

  getDaChamDiemByMaSo: (maSo, idDotTuyenDung) =>
    api.get(`/hoi-dong/da-cham-diem-by-ma-so?maSo=${maSo}&idDotTuyenDung=${idDotTuyenDung}`),

  getKetQuaChamDiem: (idTuyenDung, idDotTuyenDung) =>
    api.get(`/hoi-dong/ket-qua/${idTuyenDung}?idDotTuyenDung=${idDotTuyenDung}`),


  capNhatKetLuan: (idTuyenDung, idTrangThaiTuyenDung) =>
    api.put('/hoi-dong/ket-luan', { idTuyenDung, idTrangThaiTuyenDung }),

  capNhatTrangThai: (idTuyenDung, idTrangThaiTuyenDung) =>
    api.post('/hoi-dong/cap-nhat-trang-thai', { id: idTuyenDung, idTrangThaiTuyenDung }),

  getDotTuyenDungTheoMaSo: (maSo) =>
    api.get(`/hoi-dong/dot-tuyen-dung-theo-ma-so?maSo=${maSo}`),

  getDiemTrungBinhTheoDot: (idDotTuyenDung) =>
    api.get(`/hoi-dong/diem-trung-binh?idDotTuyenDung=${idDotTuyenDung}`),

  getBangCap: (idTuyenDung) => api.get(`/tuyen-dung/${idTuyenDung}/bang-cap`),

  getChungChi: (idTuyenDung) => api.get(`/tuyen-dung/${idTuyenDung}/chung-chi`),
};

export default tuyenDungService;
